import { API_ENDPOINTS } from "../constants/apiEndpoints";
import axiosInstance from "../config/axiosInstance";
import { normalizeUploadedImageUrl } from "./uploadImage";

/**
 * Lấy danh sách nhóm Sản phẩm - Giải pháp theo ngôn ngữ và chuẩn hóa URL hình ảnh
 * @param {string} languageCode - Mã ngôn ngữ (vd: 'vi', 'en', 'jp')
 * @returns {Promise<Array>} - Mảng nhóm: [{ id, image, imageUrl, sortOrder, name, slug }]
 */
export const getProductSolutionGroups = async (languageCode) => {
    try {
        const response = await axiosInstance.get(
            API_ENDPOINTS.PRODUCT_SOLUTION_GROUPS.GET_BY_LANGUAGE(languageCode)
        );
        const data = response.data;

        let rawItems = [];
        if (data && data.success && Array.isArray(data.data)) {
            rawItems = data.data;
        } else if (Array.isArray(data)) {
            rawItems = data;
        }

        return rawItems.map((item) => {
            const imgPath = item.image || item.imageUrl || item.imgUrl || item.ImgURL || "";
            const normalized = normalizeUploadedImageUrl(imgPath);
            return {
                ...item,
                image: normalized,
                imageUrl: normalized,
            };
        });
    } catch (error) {
        console.error(`[ProductSolutionGroups] Lỗi khi lấy groups (lang=${languageCode}):`, error.message ?? error);
        throw error;
    }
};
